import React, { useState } from "react";
import { fetchWithAuth } from "../../../Context/UserContext"; // Importa fetchWithAuth aquí
import API_URL from "../../../config";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../../components/ui/dialog";
import { Button } from "../../../components/ui/button";
import { toast } from "sonner";

const AccionesPregunta = ({ pregunta, onDelete, onReplySuccess }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isReplyModalOpen, setIsReplyModalOpen] = useState(false);
  const [respuesta, setRespuesta] = useState("");

  const openDeleteModal = () => setIsDeleteModalOpen(true);
  const closeDeleteModal = () => setIsDeleteModalOpen(false);

  const openReplyModal = () => setIsReplyModalOpen(true);
  const closeReplyModal = () => setIsReplyModalOpen(false);

  const handleDelete = () => {
    onDelete(pregunta.id_qa);
    closeDeleteModal();
  };

  const handleReply = async () => {
    if (!respuesta.trim() || respuesta.trim().length < 5) {
      toast.warning("La respuesta debe tener al menos 5 caracteres.");
      return;
    }

    try {
      const response = await fetchWithAuth(
        `${API_URL}/licit/reply_question/${pregunta.id_qa}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ respuesta: respuesta.trim() }),
        }
      );

      if (response.ok) {
        const updatedPregunta = { ...pregunta, respuesta: respuesta.trim() };
        onReplySuccess(updatedPregunta); // Notificar al componente padre
        setRespuesta("");
        closeReplyModal();
        toast.success("Respuesta enviada correctamente.");
      } else {
        const errorData = await response.json();
        toast.error(
          `Error al responder la pregunta: ${errorData.error || "Desconocido"}`
        );
      }
    } catch (error) {
      console.error("Error al responder la pregunta:", error);
      toast.error("Ocurrió un error al intentar enviar la respuesta.");
    }
  };

  return (
    <div className="mt-2 flex gap-2">
      <Button size="sm" variant="outline" onClick={openReplyModal}>
        {pregunta.respuesta ? "Modificar la respuesta" : "Responder"}
      </Button>
      <Button size="sm" variant="destructive" onClick={openDeleteModal}>
        Eliminar
      </Button>

      {/* Modal Eliminar */}
      <Dialog open={isDeleteModalOpen} onOpenChange={(open) => !open && closeDeleteModal()}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>¿Quieres realmente eliminar esta pregunta?</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-muted-foreground">{pregunta.pregunta}</p>
          <DialogFooter>
            <Button variant="outline" onClick={closeDeleteModal}>
              Cancelar
            </Button>
            <Button variant="destructive" onClick={handleDelete}>
              Confirmar
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Responder */}
      <Dialog open={isReplyModalOpen} onOpenChange={(open) => !open && closeReplyModal()}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{pregunta.respuesta ? "Editar Respuesta" : "Responder Pregunta"}</DialogTitle>
          </DialogHeader>
          <p className="text-sm text-muted-foreground">{pregunta.pregunta}</p>
          <textarea
            maxLength={300}
            value={respuesta}
            onChange={(e) => setRespuesta(e.target.value)}
            placeholder={pregunta.respuesta ? "Edita tu respuesta aquí..." : "Escribe tu respuesta aquí..."}
            rows={4}
            className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          />
          <DialogFooter>
            <Button variant="outline" onClick={closeReplyModal}>
              Cancelar
            </Button>
            <Button onClick={handleReply}>{pregunta.respuesta ? "Modificar" : "Responder"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AccionesPregunta;
